var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDisplay)?_c('div',{staticClass:"content-loader"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ripple"},[_c('div'),_c('div')])
}]

export { render, staticRenderFns }